export enum DeviceOptions {
  ManageDevices = 'devices/all-devices',
  DeviceSetup = 'device-setup'
}
